module.exports = __webpack_public_path__ + "static/media/cpp_logo.614e81bd.png";